// generated by .build/version.js
export const VERSION = '18.0.1';
